import site from '../../site';
import normalizeLocalizedSource from '../../site-locales/helpers/normalize-localized-source';
import base64Decode from '../../../utils/base64-decode';

const fetchingPromises = new Map();
const loadGlobals = (globals = [], onGlobalLoad = () => {}, locale) => {
  if (globals.length === 0) return Promise.resolve();

  const promises = globals.reduce((que, global) => {
    const fetchingPromise = fetchingPromises.get(global.id);

    if (fetchingPromise) {
      que.push(fetchingPromise);
    } else {
      const assetSource = global.localeUnaware
        ? global.source
        : normalizeLocalizedSource(global.source, locale, false);
      const promise = site.helpers
        .fetchAsset(assetSource, { encode: true })
        .then((response) => {
          fetchingPromises.delete(global.id);

          return onGlobalLoad(global, base64Decode(response.data));
        })
        .catch(() => {
          fetchingPromises.delete(global.id);
        });
      fetchingPromises.set(global.id, promise);
      que.push(promise);
    }

    return que;
  }, []);

  return Promise.all(promises);
};

export default loadGlobals;
